import React from "react";
interface InstaFeedCardProp {
  image: string;
  url?: string;
}
const InstaFeedCard = ({ image, url }: InstaFeedCardProp) => {
  return (
    <div
      className="w-auto lg:max-h-[408px] cursor-pointer relative group duration-300 flex-1"
      onClick={() => window.open(url, "_blank")}
    >
      <img src={image} className="h-full w-full object-cover" alt="" />
      <div className="h-full w-full flex justify-center items-center bg-black bg-opacity-40 absolute top-0 bottom-0 left-0 right-0 opacity-0 group-hover:opacity-100 duration-300 transition-opacity ease-in-out">
        <img
          src="/ic_insta.png"
          className="w-8 h-8 object-cover opacity-0 delay-150 group-hover:opacity-100 duration-300"
          alt=""
        />
      </div>
    </div>
  );
};

export default InstaFeedCard;
